import { FC } from 'react';

export const IntroIconA: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.1729 17.9133H15.6232C15.2103 17.9133 14.8318 17.7643 14.5393 17.5171C14.1737 17.209 13.9414 16.7483 13.9414 16.2324V7.65214C13.9414 7.14341 14.1672 6.68771 14.5242 6.3796C14.8189 6.12524 15.2031 5.97119 15.6232 5.97119H32.1729C32.6897 5.97119 33.1514 6.20406 33.4596 6.5702C33.7062 6.86254 33.8546 7.24014 33.8546 7.65214V16.2324C33.8546 16.6967 33.6661 17.1166 33.3622 17.4211C33.0575 17.7249 32.6374 17.9133 32.1729 17.9133Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.1729 41.7972H15.6232C15.1608 41.7972 14.7422 41.6109 14.4375 41.3085C14.1314 41.0047 13.9414 40.5827 13.9414 40.1162V21.585C13.9414 21.1336 14.1192 20.723 14.4088 20.4214C14.7149 20.1025 15.1457 19.9033 15.6232 19.9033H32.1729C32.6804 19.9033 33.1356 20.1283 33.4439 20.4844C33.6998 20.7796 33.8546 21.1637 33.8546 21.585V40.1162C33.8546 40.6135 33.6381 41.0606 33.2955 41.368C32.9973 41.6345 32.6044 41.7972 32.1729 41.7972Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M17.9238 8.95654V14.9273" stroke="black" strokeWidth="0.995407" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.9238 22.8892V30.8504" stroke="black" strokeWidth="0.995407" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const IntroIconB: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M36.6285 34.5719C37.1784 34.5719 37.6241 34.1263 37.6241 33.5767C37.6241 33.0271 37.1784 32.5815 36.6285 32.5815C36.0786 32.5815 35.6328 33.0271 35.6328 33.5767C35.6328 34.1263 36.0786 34.5719 36.6285 34.5719Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
            />
            <path
                d="M40.6128 34.5719C41.1627 34.5719 41.6085 34.1263 41.6085 33.5767C41.6085 33.0271 41.1627 32.5815 40.6128 32.5815C40.063 32.5815 39.6172 33.0271 39.6172 33.5767C39.6172 34.1263 40.063 34.5719 40.6128 34.5719Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
            />
            <mask id="mask0_465_2465" maskUnits="userSpaceOnUse" x="11" y="32" width="2" height="4">
                <path
                    d="M11.9959 32.0845C12.2697 32.0845 12.4937 32.3084 12.4937 32.5821V34.5724C12.4937 34.846 12.2697 35.07 11.9959 35.07C11.7221 35.07 11.498 34.846 11.498 34.5724V32.5821C11.498 32.3084 11.7171 32.0845 11.9959 32.0845Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_465_2465)">
                <path d="M12.9854 31.5869H10.9941V35.5676H12.9854V31.5869Z" fill="black" />
            </g>
            <mask id="mask1_465_2465" maskUnits="userSpaceOnUse" x="14" y="32" width="2" height="4">
                <path
                    d="M14.9724 32.0845C15.2462 32.0845 15.4703 32.3084 15.4703 32.5821V34.5724C15.4703 34.846 15.2462 35.07 14.9724 35.07C14.6986 35.07 14.4746 34.846 14.4746 34.5724V32.5821C14.4746 32.3084 14.6937 32.0845 14.9724 32.0845Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask1_465_2465)">
                <path d="M15.9679 31.5869H13.9766V35.5676H15.9679V31.5869Z" fill="black" />
            </g>
            <mask id="mask2_465_2465" maskUnits="userSpaceOnUse" x="17" y="32" width="2" height="4">
                <path
                    d="M17.9646 32.0845C18.2384 32.0845 18.4625 32.3084 18.4625 32.5821V34.5724C18.4625 34.846 18.2384 35.07 17.9646 35.07C17.6908 35.07 17.4668 34.846 17.4668 34.5724V32.5821C17.4668 32.3084 17.6858 32.0845 17.9646 32.0845Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask2_465_2465)">
                <path d="M18.9581 31.5869H16.9668V35.5676H18.9581V31.5869Z" fill="black" />
            </g>
            <mask id="mask3_465_2465" maskUnits="userSpaceOnUse" x="20" y="32" width="2" height="4">
                <path
                    d="M20.949 32.084C21.2228 32.084 21.4468 32.3079 21.4468 32.5816V34.5719C21.4468 34.8456 21.2228 35.0695 20.949 35.0695C20.6752 35.0695 20.4512 34.8456 20.4512 34.5719V32.5816C20.4512 32.3079 20.6702 32.084 20.949 32.084Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask3_465_2465)">
                <path d="M21.9464 31.5864H19.9551V35.5671H21.9464V31.5864Z" fill="black" />
            </g>
            <path
                d="M9.99565 28.6011H43.8479C44.3955 28.6011 44.8435 29.0489 44.8435 29.5962V37.5575C44.8435 38.1048 44.3955 38.5527 43.8479 38.5527H9.99565C9.44804 38.5527 9 38.1048 9 37.5575V29.5962C9 29.0489 9.44307 28.6011 9.99565 28.6011Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
            />
            <path
                d="M11.9881 26.6108H41.8577C42.1315 26.6108 42.3555 26.8348 42.3555 27.1084V28.1036C42.3555 28.3772 42.1315 28.6012 41.8577 28.6012H11.9881C11.7143 28.6012 11.4902 28.3772 11.4902 28.1036V27.1084C11.4902 26.8348 11.7093 26.6108 11.9881 26.6108Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
            />
            <path
                d="M17.9499 12.1807C17.9499 11.6334 18.3979 11.1855 18.9455 11.1855C19.4931 11.1855 19.9412 11.6334 19.9412 12.1807V21.1371H20.6381C20.668 21.1371 20.6879 21.157 20.6879 21.1869V26.6105H17.2031V21.1869C17.2031 21.157 17.223 21.1371 17.2529 21.1371H17.9499V12.1807Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
            />
            <path
                d="M24.916 17.4005C27.2508 15.0668 27.2508 11.2902 24.916 8.95654"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M23.8535 16.3459C25.6009 14.5994 25.6009 11.7632 23.8535 10.0117"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M22.8008 15.2909C23.9657 14.1265 23.9657 12.2357 22.8008 11.0664"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M12.9835 8.95654C10.6487 11.2902 10.6487 15.0668 12.9835 17.4005"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M14.0371 10.0117C12.2897 11.7582 12.2897 14.5944 14.0371 16.3459"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M15.0944 11.0664C13.9295 12.2307 13.9295 14.1215 15.0944 15.2909"
                stroke="black"
                strokeWidth="0.995407"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const IntroIconC: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.1777 37.4033H28.6103V33.0762H19.1777V37.4033Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.85927 10.4492H39.9296C40.9716 10.4492 41.8162 11.2934 41.8162 12.3349V31.4585C41.8162 32.3518 41.0919 33.0758 40.1982 33.0758H7.85927C6.81726 33.0758 5.97266 32.2316 5.97266 31.1901V12.3349C5.97266 11.2934 6.81726 10.4492 7.85927 10.4492Z"
                stroke="black"
                strokeWidth="0.995407"
            />
            <path d="M14.4629 37.4028H33.328" stroke="black" strokeWidth="0.995407" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00586 31.1708H39.7811V12.355H8.00586V31.1708Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IntroIconD: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.8843 35.8266H5.90175C5.37124 35.8266 4.89045 35.6115 4.54307 35.2637C4.19506 34.9165 3.98047 34.4365 3.98047 33.9057V13.864C3.98047 13.262 4.25674 12.7249 4.6897 12.3726C5.02072 12.104 5.44235 11.9424 5.90175 11.9424H41.8843C42.3689 11.9424 42.8113 12.1216 43.1492 12.4173C43.552 12.7689 43.8062 13.2865 43.8062 13.864V33.9057C43.8062 34.4586 43.5728 34.9567 43.1983 35.3071C42.8547 35.6297 42.3928 35.8266 41.8843 35.8266Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M32.4258 11.9424V35.8266" stroke="black" strokeWidth="0.995407" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.39453 32.4148H29.0144V15.3545H7.39453V32.4148Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M32.4258 30.1401H43.8049" stroke="black" strokeWidth="0.995407" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.3936 17.6294C40.3936 18.8855 39.3747 19.9039 38.1174 19.9039C36.8606 19.9039 35.8418 18.8855 35.8418 17.6294C35.8418 16.3733 36.8606 15.355 38.1174 15.355C39.3747 15.355 40.3936 16.3733 40.3936 17.6294Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.3936 24.4536C40.3936 25.7098 39.3747 26.7281 38.1174 26.7281C36.8606 26.7281 35.8418 25.7098 35.8418 24.4536C35.8418 23.1969 36.8606 22.1792 38.1174 22.1792C39.3747 22.1792 40.3936 23.1969 40.3936 24.4536Z"
                stroke="black"
                strokeWidth="0.995407"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IntroIconE: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.8201 34.3268C25.8201 35.4223 24.9321 36.3108 23.8361 36.3108C22.7406 36.3108 21.8516 35.4223 21.8516 34.3268C21.8516 33.2313 22.7406 32.3428 23.8361 32.3428C24.9321 32.3428 25.8201 33.2313 25.8201 34.3268Z"
                stroke="black"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.4607 31.7394C21.4607 31.9374 21.3002 32.0984 21.1017 32.0984C20.9037 32.0984 20.7422 31.9374 20.7422 31.7394C20.7422 31.5414 20.9037 31.3799 21.1017 31.3799C21.3002 31.3799 21.4607 31.5414 21.4607 31.7394Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.384 34.3883C20.384 34.5863 20.2235 34.7473 20.025 34.7473C19.827 34.7473 19.666 34.5863 19.666 34.3883C19.666 34.1903 19.827 34.0293 20.025 34.0293C20.2235 34.0293 20.384 34.1903 20.384 34.3883Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.1282 30.6456C24.1282 30.8436 23.9677 31.0051 23.7692 31.0051C23.5712 31.0051 23.4102 30.8436 23.4102 30.6456C23.4102 30.4476 23.5712 30.2866 23.7692 30.2866C23.9677 30.2866 24.1282 30.4476 24.1282 30.6456Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.8083 31.7477C26.8083 31.9457 26.6473 32.1067 26.4488 32.1067C26.2513 32.1067 26.0898 31.9457 26.0898 31.7477C26.0898 31.5497 26.2513 31.3887 26.4488 31.3887C26.6473 31.3887 26.8083 31.5497 26.8083 31.7477Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.908 34.4078C27.908 34.6058 27.747 34.7668 27.5485 34.7668C27.3505 34.7668 27.1895 34.6058 27.1895 34.4078C27.1895 34.2098 27.3505 34.0488 27.5485 34.0488C27.747 34.0488 27.908 34.2098 27.908 34.4078Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M24.327 34.9349L23.1875 33.7944" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.2805 31.4561C29.0945 27.8586 29.8635 26.5596 29.8635 26.5596H29.663H17.8955H17.6945C17.6945 26.5596 18.464 27.8586 16.277 31.4561C14.0915 35.0531 14.5375 38.1936 14.5375 38.1936V39.4811C14.5375 40.5231 15.3825 41.3686 16.425 41.3686H22.8365H24.7215H31.1335C32.176 41.3686 33.021 40.5231 33.021 39.4811V38.1936C33.021 38.1936 33.467 35.0531 31.2805 31.4561Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.5371 38.1939H18.6841C18.9646 38.1939 19.2326 38.3054 19.4306 38.5034L20.1161 39.1889C20.3146 39.3874 20.5826 39.4974 20.8631 39.4974H26.4251C26.7046 39.4974 26.9731 39.3874 27.1716 39.1889L28.0451 38.3144C28.2426 38.1169 28.5111 38.0054 28.7911 38.0054H33.0211"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M17.709 28.2305H29.8495" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M32.4363 8.06473L15.1113 7.96973L16.6328 9.41673C16.6328 9.41673 16.7493 25.3107 19.0268 26.3862"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M31.7427 8.06104C31.7427 8.06104 31.2687 25.311 28.9902 26.3855" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.9141 11.8594C19.9141 11.8594 20.2451 21.0269 21.2101 23.4149" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M28.1788 11.8594C28.1788 11.8594 27.8478 21.0269 26.8828 23.4149" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24.0645 11.8467V23.4152" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.6019 6.80469H19.3754C18.7319 6.80469 18.2109 7.32619 18.2109 7.96919H29.7669C29.7669 7.32619 29.2454 6.80469 28.6019 6.80469Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.6894 6.7075C24.6894 6.317 24.3724 6 23.9814 6C23.5909 6 23.2734 6.317 23.2734 6.7075"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7734 41.9022H18.3049V41.3687H16.7734V41.9022Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.6523 41.9022H31.1838V41.3687H29.6523V41.9022Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IntroIconF: FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <g clipPath="url(#clip0_2346_6024)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.8427 41.2788H12.2464C11.0506 41.2788 10.0801 40.309 10.0801 39.1124V8.88507C10.0801 7.68854 11.0506 6.71875 12.2464 6.71875H35.8427C37.0392 6.71875 38.009 7.68854 38.009 8.88507V39.1124C38.009 40.309 37.0392 41.2788 35.8427 41.2788Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4298 27.1973C14.4695 32.5611 18.7596 36.8453 24.0642 36.8173C29.3861 36.789 33.6783 32.4751 33.6524 27.1785C33.6256 21.8544 29.3355 17.5868 24.0143 17.5918C18.7271 17.5976 14.3908 21.9425 14.4298 27.1973Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.583 10.238C17.5628 11.3371 16.6508 12.2267 15.5756 12.1971C14.4556 12.1661 13.6042 11.2699 13.6259 10.1434C13.6454 9.10361 14.561 8.21903 15.6059 8.23058C16.7158 8.24358 17.6033 9.14404 17.583 10.238Z"
                    stroke="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.0517 27.209C32.0524 31.6391 28.4325 35.2453 24.0153 35.2149C19.591 35.1846 16.0231 31.6095 16.0303 27.214C16.0375 22.7694 19.6184 19.1892 24.0543 19.1914C28.4707 19.1936 32.0509 22.7832 32.0517 27.209Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.3362 10.5131H23.0583V9.79102H22.3362V10.5131Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.7561 10.5131H26.4782V9.79102H25.7561V10.5131Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.1759 10.5131H29.898V9.79102H29.1759V10.5131Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1769 28.7662C16.1769 28.7662 19.6444 24.4047 23.9626 28.7215C28.2801 33.0389 32.0488 27.847 32.0488 27.847"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path d="M10.0803 13.7109H38.0092" stroke="black" />
            </g>
            <defs>
                <clipPath id="clip0_2346_6024">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconG: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.68299 17.5801H39.3869L42.4268 22.6833V37.046C42.4268 38.8133 40.9941 40.246 39.2268 40.246H8.79961C7.0323 40.246 5.59961 38.8133 5.59961 37.046V22.6833L8.68299 17.5801Z"
                stroke="black"
                strokeLinejoin="round"
            />
            <path d="M5.59961 23.0513H42.4268" stroke="black" />
            <path d="M24.8145 23.0511V19.9248H28.8174V23.0511" stroke="black" strokeLinejoin="round" />
            <path d="M32.0215 23.0516V19.9253H36.8215V23.0516" stroke="black" strokeLinejoin="round" />
            <path
                d="M7.38069 8L40.6266 8.04283C41.9392 8.04452 43.0018 9.02773 43 10.2389C43 10.4596 42.9632 10.6785 42.8923 10.8884L42.81 11.095L40.0821 17.0064C39.9756 17.2371 39.7501 17.3986 39.4882 17.4404L39.3546 17.451L8.6574 17.5C8.38365 17.5004 8.13261 17.3708 7.9885 17.1628L7.92574 17.0524L5.18652 11.0433C4.6776 9.92682 5.24592 8.64111 6.45589 8.17153C6.67545 8.08632 6.90723 8.03221 7.14337 8.01065L7.38069 8ZM7.38069 8.93906C7.27483 8.93892 6.92022 8.93906 6.67282 9.17288C5.93063 9.64052 6.09657 10.2375 6.17803 10.5758L8.96304 16.6552H39.0817L41.9155 10.5092L41.9504 10.4169L41.9716 10.3214L41.9788 10.2239C42.0504 9.8593 41.5829 8.98638 41.2134 8.92401L40.566 8.93906H28.691V9.4067C28.5636 10.2239 27.7015 10.342 27.2067 10.342H20.3773C19.5359 10.342 19.3417 9.70343 19.29 8.93906H7.38069Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.38 28.2002C13.541 28.2002 13.6715 28.3307 13.6715 28.4917L13.6714 29.9154L14.4242 29.3537C14.5436 29.2644 14.7128 29.2887 14.8022 29.4081L14.8334 29.4616C14.9133 29.6442 14.857 29.8579 14.6974 29.9774L13.6714 30.7442L13.6715 32.7087C13.6715 32.8697 13.541 33.0002 13.38 33.0002C13.219 33.0002 13.0885 32.8697 13.0885 32.7087L13.0874 30.7442L12.0627 29.9774C11.9031 29.8579 11.8467 29.6442 11.9267 29.4616C11.9865 29.325 12.1457 29.2627 12.2823 29.3226L12.3358 29.3537L13.0874 29.9154L13.0885 28.4917C13.0885 28.3307 13.219 28.2002 13.38 28.2002Z"
                fill="black"
                stroke="black"
                strokeWidth="0.32"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3836 37.8003C13.2227 37.8003 13.0921 37.6698 13.0921 37.5088L13.0922 36.0851L12.3394 36.6468C12.22 36.7361 12.0508 36.7118 11.9615 36.5924L11.9303 36.5389C11.8503 36.3563 11.9067 36.1426 12.0663 36.0231L13.0922 35.2563L13.0921 32.8892C13.0921 32.7282 13.2227 32.5977 13.3836 32.5977C13.5446 32.5977 13.6751 32.7282 13.6751 32.8892L13.6762 35.2563L14.701 36.0231C14.8606 36.1426 14.917 36.3563 14.837 36.5389C14.7772 36.6755 14.6179 36.7378 14.4813 36.6779L14.4279 36.6468L13.6762 36.0851L13.6751 37.5088C13.6751 37.6698 13.5446 37.8003 13.3836 37.8003Z"
                fill="black"
                stroke="black"
                strokeWidth="0.32"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5396 30.6004C17.6201 30.7398 17.5723 30.9181 17.4329 30.9986L16.1999 31.7104L17.0628 32.0815C17.1998 32.1402 17.2633 32.2989 17.2046 32.436L17.1739 32.4897C17.0557 32.6503 16.8425 32.7084 16.6592 32.6298L15.4822 32.1248L13.4323 33.3084C13.2928 33.3889 13.1146 33.3411 13.0341 33.2017C12.9536 33.0623 13.0013 32.884 13.1408 32.8035L15.1902 31.619L15.3419 30.3481C15.3655 30.1502 15.5224 29.9945 15.7206 29.9725C15.8688 29.956 16.0023 30.0628 16.0188 30.211L16.0185 30.2728L15.9079 31.2046L17.1414 30.4937C17.2808 30.4132 17.4591 30.461 17.5396 30.6004Z"
                fill="black"
                stroke="black"
                strokeWidth="0.32"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.22405 35.4001C9.14355 35.2607 9.19132 35.0824 9.33075 35.0019L10.5638 34.2901L9.70091 33.919C9.56384 33.8603 9.50032 33.7016 9.55905 33.5645L9.58977 33.5108C9.70795 33.3502 9.92117 33.2921 10.1045 33.3707L11.2815 33.8757L13.3314 32.6921C13.4708 32.6116 13.6491 32.6594 13.7296 32.7988C13.8101 32.9382 13.7623 33.1165 13.6229 33.197L11.5735 34.3815L11.4218 35.6523C11.3981 35.8503 11.2413 36.006 11.0431 36.028C10.8949 36.0445 10.7614 35.9377 10.7449 35.7895L10.7451 35.7276L10.8558 34.7959L9.62225 35.5068C9.48283 35.5873 9.30455 35.5395 9.22405 35.4001Z"
                fill="black"
                stroke="black"
                strokeWidth="0.32"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5405 35.4002C17.46 35.5396 17.2817 35.5874 17.1423 35.5069L15.9094 34.795L16.0194 35.7278C16.0371 35.8758 15.9314 36.0102 15.7833 36.0279L15.7214 36.0281C15.5232 36.0061 15.3664 35.8505 15.3427 35.6525L15.1916 34.3806L13.1416 33.1971C13.0022 33.1166 12.9544 32.9383 13.0349 32.7989C13.1154 32.6595 13.2937 32.6117 13.4331 32.6922L15.4836 33.8748L16.66 33.3708C16.8433 33.2923 17.0565 33.3503 17.1747 33.5109C17.2631 33.631 17.2374 33.8 17.1173 33.8884L17.0636 33.9191L16.2014 34.2892L17.4338 35.002C17.5732 35.0825 17.621 35.2608 17.5405 35.4002Z"
                fill="black"
                stroke="black"
                strokeWidth="0.32"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.22322 30.6003C9.30371 30.4609 9.48199 30.4131 9.62142 30.4936L10.8543 31.2055L10.7443 30.2727C10.7266 30.1246 10.8323 29.9903 10.9804 29.9726L11.0423 29.9723C11.2404 29.9944 11.3973 30.15 11.421 30.348L11.5721 31.6199L13.6221 32.8034C13.7615 32.8839 13.8093 33.0621 13.7288 33.2016C13.6483 33.341 13.47 33.3888 13.3306 33.3083L11.2801 32.1257L10.1036 32.6297C9.92034 32.7082 9.70712 32.6502 9.58894 32.4896C9.50055 32.3695 9.52626 32.2005 9.64637 32.1121L9.70008 32.0814L10.5623 31.7113L9.32991 30.9985C9.19049 30.918 9.14272 30.7397 9.22322 30.6003Z"
                fill="black"
                stroke="black"
                strokeWidth="0.32"
            />
        </svg>
    );
};

export const IntroIconH: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 10.647V18.7462C8 19.1526 8.32896 19.4816 8.73472 19.4816H10.7584L15.3485 21.152H28.2784H37.7926C39.0099 21.152 39.9974 20.1651 39.9974 18.9472V10.2048C39.9974 8.98752 39.0099 8 37.7926 8H15.4925L10.6995 9.91872L8.73728 9.91232C8.33024 9.91104 8 10.2406 8 10.647Z"
                stroke="black"
            />
            <path
                d="M35.3875 21.1523V36.4746C35.3875 38.4221 33.8092 40.0003 31.8617 40.0003C29.9148 40.0003 28.3359 38.4221 28.3359 36.4746V21.1523"
                stroke="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.0566 33.4843H29.5625C28.895 33.4843 28.3535 32.9435 28.3535 32.276V28.3592C28.3535 27.6917 28.895 27.1509 29.5625 27.1509H30.0566C30.7234 27.1509 31.2649 27.6917 31.2649 28.3592V32.276C31.2649 32.9435 30.7234 33.4843 30.0566 33.4843Z"
                stroke="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.0566 30.2115H29.5625C28.895 30.2115 28.3535 29.6707 28.3535 29.0032V28.3587C28.3535 27.6918 28.895 27.1504 29.5625 27.1504H30.0566C30.7234 27.1504 31.2649 27.6918 31.2649 28.3587V29.0032C31.2649 29.6707 30.7234 30.2115 30.0566 30.2115Z"
                stroke="black"
            />
            <path d="M8 12.8853H11.2365" stroke="black" strokeLinecap="round" />
            <path d="M8 16.1387H11.2365" stroke="black" strokeLinecap="round" />
            <path d="M36.668 17.9404H39.9051" stroke="black" strokeLinecap="round" />
            <path d="M36.668 14.6445H39.9051" stroke="black" strokeLinecap="round" />
            <path d="M36.668 11.3486H39.9051" stroke="black" strokeLinecap="round" />
            <path d="M15.3496 21.152V8" stroke="black" />
        </svg>
    );
};

export const IntroIconI: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2231)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 39.8114H20.8461V8H16.9155C11.9917 8 8 11.9911 8 16.9155V39.8114Z"
                    stroke="black"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.93 10.8301H20.8477V18.3878H35.3498V15.25C35.3498 12.8087 33.3712 10.8301 30.93 10.8301Z"
                    stroke="black"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.9105 34.8301H20.8477V39.5891H40.0013V37.9209C40.0013 36.2139 38.6175 34.8301 36.9105 34.8301Z"
                    stroke="black"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.4186 30.6208C34.4186 32.9455 32.5341 34.8301 30.2093 34.8301C27.8845 34.8301 26 32.9455 26 30.6208V27.8105H34.4186V29.877V30.6208Z"
                    stroke="black"
                    strokeLinejoin="round"
                />
                <path d="M37.4496 29.9365H34.418" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M28.3008 21.7005H31.6136V18.3877H28.3008V21.7005Z" stroke="black" strokeLinejoin="round" />
                <path d="M11.875 13.248H17.2849" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.875 16.0938H17.2849" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3551 30.0262C17.3551 31.5754 16.0998 32.8307 14.5506 32.8307C13.002 32.8307 11.7461 31.5754 11.7461 30.0262C11.7461 28.477 13.002 27.2217 14.5506 27.2217C16.0998 27.2217 17.3551 28.477 17.3551 30.0262Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_450_2231">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconJ: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2260)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M39.8087 36.3178H8.19129C6.98097 36.3178 6 35.3369 6 34.1265V13.6913C6 12.4817 6.98097 11.5 8.19129 11.5H39.8087C41.019 11.5 42 12.4817 42 13.6913V34.1265C42 35.3369 41.019 36.3178 39.8087 36.3178Z"
                    stroke="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M37.789 27.4084H10.4921C9.68499 27.4084 9.03125 26.7539 9.03125 25.9475V15.2255C9.03125 14.4191 9.68499 13.7646 10.4921 13.7646H37.789C38.5954 13.7646 39.2499 14.4191 39.2499 15.2255V25.9475C39.2499 26.7539 38.5954 27.4084 37.789 27.4084Z"
                    stroke="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M39.8087 29.8401H8.19129C6.98097 29.8401 6 28.8592 6 27.6488V13.6918C6 12.4815 6.98097 11.5005 8.19129 11.5005H39.8087C41.019 11.5005 42 12.4815 42 13.6918V27.6488C42 28.8592 41.019 29.8401 39.8087 29.8401Z"
                    stroke="black"
                />
                <path d="M12.2539 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M15.2266 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M18.1973 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M21.168 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M24.1406 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M27.1113 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M30.082 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M33.0547 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path d="M36.0234 15.124V25.9395" stroke="black" strokeLinecap="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2492 32.8681C12.2492 33.0727 12.0834 33.2392 11.8781 33.2392C11.6736 33.2392 11.5078 33.0727 11.5078 32.8681C11.5078 32.6636 11.6736 32.4971 11.8781 32.4971C12.0834 32.4971 12.2492 32.6636 12.2492 32.8681Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5793 32.8681C16.5793 33.0727 16.4135 33.2392 16.2089 33.2392C16.0037 33.2392 15.8379 33.0727 15.8379 32.8681C15.8379 32.6636 16.0037 32.4971 16.2089 32.4971C16.4135 32.4971 16.5793 32.6636 16.5793 32.8681Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.9433 32.8681C32.9433 33.0727 32.7768 33.2392 32.5722 33.2392C32.3677 33.2392 32.2012 33.0727 32.2012 32.8681C32.2012 32.6636 32.3677 32.4971 32.5722 32.4971C32.7768 32.4971 32.9433 32.6636 32.9433 32.8681Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M37.2746 32.8681C37.2746 33.0727 37.1088 33.2392 36.9035 33.2392C36.699 33.2392 36.5332 33.0727 36.5332 32.8681C36.5332 32.6636 36.699 32.4971 36.9035 32.4971C37.1088 32.4971 37.2746 32.6636 37.2746 32.8681Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.1101 33.239C26.1101 34.3274 25.2277 35.2104 24.1387 35.2104C23.0503 35.2104 22.168 34.3274 22.168 33.239C22.168 32.1499 23.0503 31.2676 24.1387 31.2676C25.2277 31.2676 26.1101 32.1499 26.1101 33.239Z"
                    stroke="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_450_2260">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconK: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M37.2685 19.3467H42.427C43.296 19.3467 44 20.0507 44 20.9197V34.4342H4V20.9197C4 20.0507 4.704 19.3467 5.573 19.3467H25.37"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.632 23.6011C38.632 27.6421 35.3565 30.9171 31.3165 30.9171C27.2755 30.9171 24 27.6421 24 23.6011C24 19.5611 27.2755 16.2856 31.3165 16.2856C35.3565 16.2856 38.632 19.5611 38.632 23.6011Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.9745 23.7362C35.9745 26.2312 33.952 28.2538 31.457 28.2538C28.962 28.2538 26.9395 26.2312 26.9395 23.7362C26.9395 21.2413 28.962 19.2188 31.457 19.2188C33.952 19.2188 35.9745 21.2413 35.9745 23.7362Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6.21484 35.5571V36.7146H11.0833V35.5571" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M36.916 35.5571V36.7146H41.7845V35.5571" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 23.2412H20.4215" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 26.978H20.4215" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 30.7153H20.596" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M41.7852 21.6626V24.8201" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M31.4551 10.5V12.404" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22.7656 13.6909L24.1111 15.0364" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26.6953 11.5405L27.4973 13.267" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M28.7012 23.6012C28.7012 22.1722 29.8597 21.0132 31.2892 21.0132" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M31.4551 10.5V12.404" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M40.1468 13.6909L38.8008 15.0364" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M36.218 11.5405L35.416 13.267" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const IntroIconL: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34.5493 41.248C34.2383 41.632 33.7633 41.8765 33.2303 41.8765H15.6973" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M34.3984 6.46533C34.7239 6.77433 34.9274 7.21233 34.9274 7.69683V40.1793C34.9274 40.5838 34.7854 40.9553 34.5484 41.2473"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.3984 6.6025C14.7099 6.234 15.1754 6 15.6964 6H33.2294C33.6824 6 34.0939 6.176 34.3984 6.4655"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M14 40.179V7.69654C14 7.27954 14.15 6.89754 14.3995 6.60254" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.414 41.2902C14.1565 40.9922 14 40.6042 14 40.1792" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.6976 41.8765C15.1851 41.8765 14.7261 41.649 14.4141 41.29" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0664 35.8846H32.8629V10.0571H16.0664V35.8846Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.9587 38.7689C25.9587 39.5944 25.2892 40.2634 24.4642 40.2634C23.6377 40.2634 22.9688 39.5944 22.9688 38.7689C22.9688 37.9439 23.6377 37.2744 24.4642 37.2744C25.2892 37.2744 25.9587 37.9439 25.9587 38.7689Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M21.6973 7.49414H22.4428" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23.2891 7.49414H25.9606" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const IntroIconM: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2316)">
                <path
                    d="M8.9043 28.0257C8.9043 21.9197 13.8543 16.9697 19.9603 16.9697C26.0663 16.9697 31.0163 21.9197 31.0163 28.0257"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.9043 28.0257C8.9043 21.9197 13.8543 16.9697 19.9603 16.9697C26.0663 16.9697 31.0163 21.9197 31.0163 28.0257"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6367 28.0253C14.6367 25.0856 17.0202 22.7021 19.9604 22.7021C22.9001 22.7021 25.2836 25.0856 25.2836 28.0253"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.6466 33.9323C22.5775 34.6006 21.3147 34.9864 19.9613 34.9864C18.2437 34.9864 16.6707 34.3643 15.457 33.333"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.0938 28.0256C17.0938 26.4424 18.377 25.1592 19.9602 25.1592C21.5434 25.1592 22.8266 26.4424 22.8266 28.0256"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.9297 30.892H5L6.63779 28.2764H33.473L35.9297 30.892Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.9183 30.9365L28.1474 31.1687L28.5649 31.8568L27.7742 32.0068L28.1174 32.7351L27.3153 32.8017L27.581 33.5618L26.7759 33.5444L26.9601 34.3279L26.1616 34.2265L26.263 35.025L25.4795 34.8408L25.4969 35.6453L24.7368 35.3802L24.6702 36.1823L23.9419 35.8391L23.7919 36.6298L23.1038 36.2123L22.8716 36.9832L22.2309 36.496L21.9189 37.2381L21.3328 36.6868L20.9453 37.3929L20.4197 36.7828L19.9614 37.4445L19.5024 36.7828L18.9769 37.3929L18.5894 36.6868L18.0032 37.2381L17.6919 36.496L17.0505 36.9832L16.819 36.2123L16.1309 36.6298L15.9803 35.8391L15.252 36.1823L15.1854 35.3802L14.4253 35.6453L14.4433 34.8408L13.6592 35.025L13.7606 34.2265L12.9621 34.3279L13.1468 33.5444L12.3417 33.5618L12.6075 32.8017L11.8048 32.7351L12.148 32.0068L11.3573 31.8568L11.7748 31.1687L11.0039 30.9365"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path d="M30.5625 24.313H36.9403" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M31.125 27.3433H36.9401" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40.9086 28.3533H39.0314C37.8759 28.3533 36.9395 27.4168 36.9395 26.262V17.3141C36.9395 16.1587 37.8759 15.2222 39.0314 15.2222H40.9086C42.0634 15.2222 42.9999 16.1587 42.9999 17.3141V26.262C42.9999 27.4168 42.0634 28.3533 40.9086 28.3533Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M38.9609 15.2227V28.3538" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M36.83 16.2989C33.3582 13.6047 29.2811 11.6063 24.7775 10.5481C23.9592 10.3561 23.1157 10.7526 22.7306 11.4995L19.9121 16.957"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M36.8664 20.6902C33.9622 17.9485 30.4544 15.8026 26.5147 14.484C25.6544 14.196 24.7113 14.5716 24.2908 15.3755L23.2109 17.4374"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22.8945 19.8145C24.1994 20.292 25.365 21.0611 26.3111 22.042" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_450_2316">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconN: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2361)">
                <path d="M10.8535 9.62402V15.3317" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.8535 11.2144H16.7318" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.8535 13.8838H16.7318" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M37.0938 15.3317V9.62402" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M37.0931 13.7412H31.2148" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M37.0931 11.0723H31.2148" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7324 14.3946V8.05734C16.7324 7.19724 17.4297 6.5 18.2891 6.5H29.6578C30.5179 6.5 31.2145 7.19724 31.2145 8.05734V18.1712H28.9098C28.0497 18.1712 27.3525 18.8685 27.3525 19.7279V23.5102H20.3385V19.785C20.3385 18.9256 19.6419 18.2283 18.7818 18.2283H16.7324V14.3946Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M21.5879 9.82275V15.3316" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.8887 9.82275V15.3316" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M26.3594 9.82275V15.3316" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.5879 31.5752H26.3586V23.5107H21.5879V31.5752Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.959 41.5001H24.9866V31.5752H22.959V41.5001Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M34.985 31.0425L30.853 35.1745L32.5034 36.8249L28.8516 40.4775" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.0254 30.7231L17.1574 34.8544L15.507 36.5055L19.1596 40.1581" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_450_2361">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconO: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2348)">
                <path
                    d="M10.2227 30.8564V37.6402C10.2227 37.9902 10.5062 38.2731 10.8556 38.2731H38.1641C38.5141 38.2731 38.797 37.9902 38.797 37.6402V35.511C38.797 35.1616 38.5141 34.8781 38.1641 34.8781H16.1172C15.7678 34.8781 15.4842 34.5945 15.4842 34.2451V30.2861"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5234 38.2734V40.0001" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M35.5996 38.2734V40.0001" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M31.1208 17.439C33.5873 20.741 33.481 25.4297 30.6341 28.6279C27.5688 32.0724 22.4199 32.561 18.7773 29.8856"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.2574 24.0745C12.6378 20.7978 13.6258 17.2825 16.2006 14.7894C20.271 10.8494 26.7642 10.9544 30.7042 15.0248L27.287 18.4439C25.2382 16.6439 22.1413 16.7116 20.1475 18.642C18.05 20.6725 17.688 23.9169 19.7184 26.0151L13.6556 32.0798C13.0619 32.6735 12.1011 32.6779 11.503 32.0906L9.45796 30.0823C8.85288 29.488 8.84655 28.5151 9.44403 27.9132L13.2574 24.0745Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.324 13.8301L32.8665 10.2876C33.114 10.0401 33.114 9.63945 32.8665 9.39198L31.6595 8.18561C31.4126 7.93813 31.012 7.93813 30.7645 8.18561L26.5391 12.4111"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.8399 22.8448C24.8399 23.246 24.5146 23.5714 24.1133 23.5714C23.712 23.5714 23.3867 23.246 23.3867 22.8448C23.3867 22.4435 23.712 22.1182 24.1133 22.1182C24.5146 22.1182 24.8399 22.4435 24.8399 22.8448Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.3106 29.3384C13.3106 29.7397 12.9853 30.065 12.584 30.065C12.1827 30.065 11.8574 29.7397 11.8574 29.3384C11.8574 28.9371 12.1827 28.6118 12.584 28.6118C12.9853 28.6118 13.3106 28.9371 13.3106 29.3384Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_450_2348">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconP: FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.7637 15.5142C31.2797 15.5142 32.5137 14.2802 32.5137 12.7642C32.5137 11.2482 31.2797 10.0142 29.7637 10.0142C28.2477 10.0142 27.0137 11.2482 27.0137 12.7642C27.0137 14.2802 28.2477 15.5142 29.7637 15.5142ZM29.7637 11.0142C30.7287 11.0142 31.5137 11.7992 31.5137 12.7642C31.5137 13.7292 30.7287 14.5142 29.7637 14.5142C28.7987 14.5142 28.0137 13.7292 28.0137 12.7642C28.0137 11.7992 28.7987 11.0142 29.7637 11.0142Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.2637 12.7642C34.2637 15.2457 32.2452 17.2642 29.7637 17.2642C27.2822 17.2642 25.2637 15.2457 25.2637 12.7642C25.2637 10.2827 27.2822 8.26416 29.7637 8.26416C32.2452 8.26416 34.2637 10.2827 34.2637 12.7642ZM33.2637 12.7642C33.2637 10.8347 31.6932 9.26416 29.7637 9.26416C27.8342 9.26416 26.2637 10.8347 26.2637 12.7642C26.2637 14.6937 27.8342 16.2642 29.7637 16.2642C31.6932 16.2642 33.2637 14.6937 33.2637 12.7642Z"
                fill="black"
            />
            <path
                d="M14.2637 11.0142C14.2637 10.7377 14.4872 10.5142 14.7637 10.5142C15.0397 10.5142 15.2637 10.7377 15.2637 11.0142V13.0142C15.2637 13.2907 15.0397 13.5142 14.7637 13.5142C14.4872 13.5142 14.2637 13.2907 14.2637 13.0142V11.0142Z"
                fill="black"
            />
            <path
                d="M16.7637 10.5142C16.4872 10.5142 16.2637 10.7377 16.2637 11.0142V13.0142C16.2637 13.2907 16.4872 13.5142 16.7637 13.5142C17.0397 13.5142 17.2637 13.2907 17.2637 13.0142V11.0142C17.2637 10.7377 17.0397 10.5142 16.7637 10.5142Z"
                fill="black"
            />
            <path
                d="M18.2637 11.0142C18.2637 10.7377 18.4872 10.5142 18.7637 10.5142C19.0397 10.5142 19.2637 10.7377 19.2637 11.0142V13.0142C19.2637 13.2907 19.0397 13.5142 18.7637 13.5142C18.4872 13.5142 18.2637 13.2907 18.2637 13.0142V11.0142Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.264 15.5285H12.264C11.98 15.5285 11.75 15.2985 11.75 15.0145V9.0145C11.75 8.73 11.98 8.5 12.264 8.5H21.264C21.5485 8.5 21.7785 8.73 21.7785 9.0145V15.0145C21.7785 15.2985 21.5485 15.5285 21.264 15.5285ZM20.75 14.5H12.7785V9.5285H20.75V14.5Z"
                fill="black"
            />
            <path
                d="M21.5137 34.7642C21.5137 35.0407 21.2897 35.2642 21.0137 35.2642C20.7372 35.2642 20.5137 35.0407 20.5137 34.7642V34.0142H19.7637C19.4872 34.0142 19.2637 33.7907 19.2637 33.5142C19.2637 33.2377 19.4872 33.0142 19.7637 33.0142H20.5137V32.2642C20.5137 31.9877 20.7372 31.7642 21.0137 31.7642C21.2897 31.7642 21.5137 31.9877 21.5137 32.2642V33.0142H22.2637C22.5397 33.0142 22.7637 33.2377 22.7637 33.5142C22.7637 33.7907 22.5397 34.0142 22.2637 34.0142H21.5137V34.7642Z"
                fill="black"
            />
            <path
                d="M27.7637 33.5142C27.7637 33.2377 27.5397 33.0142 27.2637 33.0142H24.7637C24.4872 33.0142 24.2637 33.2377 24.2637 33.5142C24.2637 33.7907 24.4872 34.0142 24.7637 34.0142H27.2637C27.5397 34.0142 27.7637 33.7907 27.7637 33.5142Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.25 33.514C13.25 32.679 13.929 32 14.764 32C15.599 32 16.278 32.679 16.278 33.514C16.278 34.349 15.599 35.0285 14.764 35.0285C13.929 35.0285 13.25 34.349 13.25 33.514ZM14.278 33.514C14.278 33.7815 14.4965 34 14.764 34C15.0315 34 15.25 33.7815 15.25 33.514C15.25 33.2465 15.0315 33.0285 14.764 33.0285C14.4965 33.0285 14.278 33.2465 14.278 33.514Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.764 30.5C13.102 30.5 11.75 31.852 11.75 33.514C11.75 35.1765 13.102 36.5285 14.764 36.5285C16.426 36.5285 17.778 35.1765 17.778 33.514C17.778 31.852 16.426 30.5 14.764 30.5ZM14.764 35.5C13.6695 35.5 12.778 34.609 12.778 33.514C12.778 32.4195 13.6695 31.5285 14.764 31.5285C15.8585 31.5285 16.75 32.4195 16.75 33.514C16.75 34.609 15.8585 35.5 14.764 35.5Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.75 33.514C30.75 32.679 31.429 32 32.264 32C33.099 32 33.778 32.679 33.778 33.514C33.778 34.349 33.099 35.0285 32.264 35.0285C31.429 35.0285 30.75 34.349 30.75 33.514ZM31.778 33.514C31.778 33.7815 31.9965 34 32.264 34C32.5315 34 32.75 33.7815 32.75 33.514C32.75 33.2465 32.5315 33.0285 32.264 33.0285C31.9965 33.0285 31.778 33.2465 31.778 33.514Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.264 30.5C30.602 30.5 29.25 31.852 29.25 33.514C29.25 35.1765 30.602 36.5285 32.264 36.5285C33.926 36.5285 35.278 35.1765 35.278 33.514C35.278 31.852 33.926 30.5 32.264 30.5ZM32.264 35.5C31.1695 35.5 30.278 34.609 30.278 33.514C30.278 32.4195 31.1695 31.5285 32.264 31.5285C33.3585 31.5285 34.25 32.4195 34.25 33.514C34.25 34.609 33.3585 35.5 32.264 35.5Z"
                fill="black"
            />
            <path
                d="M17.2637 38.0142H12.2637C11.9872 38.0142 11.7637 38.2377 11.7637 38.5142C11.7637 38.7907 11.9872 39.0142 12.2637 39.0142H17.2637C17.5402 39.0142 17.7637 38.7907 17.7637 38.5142C17.7637 38.2377 17.5402 38.0142 17.2637 38.0142Z"
                fill="black"
            />
            <path
                d="M21.0137 38.0142H26.0137C26.2902 38.0142 26.5137 38.2377 26.5137 38.5142C26.5137 38.7907 26.2902 39.0142 26.0137 39.0142H21.0137C20.7372 39.0142 20.5137 38.7907 20.5137 38.5142C20.5137 38.2377 20.7372 38.0142 21.0137 38.0142Z"
                fill="black"
            />
            <path
                d="M34.7637 38.0142H29.7637C29.4872 38.0142 29.2637 38.2377 29.2637 38.5142C29.2637 38.7907 29.4872 39.0142 29.7637 39.0142H34.7637C35.0402 39.0142 35.2637 38.7907 35.2637 38.5142C35.2637 38.2377 35.0402 38.0142 34.7637 38.0142Z"
                fill="black"
            />
            <path
                d="M12.2637 27.5142H17.2637C17.5397 27.5142 17.7637 27.7377 17.7637 28.0142C17.7637 28.2907 17.5397 28.5142 17.2637 28.5142H12.2637C11.9872 28.5142 11.7637 28.2907 11.7637 28.0142C11.7637 27.7377 11.9872 27.5142 12.2637 27.5142Z"
                fill="black"
            />
            <path
                d="M34.7637 27.5142H29.7637C29.4872 27.5142 29.2637 27.7377 29.2637 28.0142C29.2637 28.2907 29.4872 28.5142 29.7637 28.5142H34.7637C35.0397 28.5142 35.2637 28.2907 35.2637 28.0142C35.2637 27.7377 35.0397 27.5142 34.7637 27.5142Z"
                fill="black"
            />
            <path
                d="M21.0137 27.5142H26.0137C26.2897 27.5142 26.5137 27.7377 26.5137 28.0142C26.5137 28.2907 26.2897 28.5142 26.0137 28.5142H21.0137C20.7372 28.5142 20.5137 28.2907 20.5137 28.0142C20.5137 27.7377 20.7372 27.5142 21.0137 27.5142Z"
                fill="black"
            />
            <path
                d="M17.2637 25.0142H12.2637C11.9872 25.0142 11.7637 25.2377 11.7637 25.5142C11.7637 25.7907 11.9872 26.0142 12.2637 26.0142H17.2637C17.5397 26.0142 17.7637 25.7907 17.7637 25.5142C17.7637 25.2377 17.5397 25.0142 17.2637 25.0142Z"
                fill="black"
            />
            <path
                d="M29.7637 25.0142H34.7637C35.0397 25.0142 35.2637 25.2377 35.2637 25.5142C35.2637 25.7907 35.0397 26.0142 34.7637 26.0142H29.7637C29.4872 26.0142 29.2637 25.7907 29.2637 25.5142C29.2637 25.2377 29.4872 25.0142 29.7637 25.0142Z"
                fill="black"
            />
            <path
                d="M26.0137 25.0142H21.0137C20.7372 25.0142 20.5137 25.2377 20.5137 25.5142C20.5137 25.7907 20.7372 26.0142 21.0137 26.0142H26.0137C26.2897 26.0142 26.5137 25.7907 26.5137 25.5142C26.5137 25.2377 26.2897 25.0142 26.0137 25.0142Z"
                fill="black"
            />
            <path
                d="M12.2637 22.5142H17.2637C17.5397 22.5142 17.7637 22.7377 17.7637 23.0142C17.7637 23.2907 17.5397 23.5142 17.2637 23.5142H12.2637C11.9872 23.5142 11.7637 23.2907 11.7637 23.0142C11.7637 22.7377 11.9872 22.5142 12.2637 22.5142Z"
                fill="black"
            />
            <path
                d="M34.7637 22.5142H29.7637C29.4872 22.5142 29.2637 22.7377 29.2637 23.0142C29.2637 23.2907 29.4872 23.5142 29.7637 23.5142H34.7637C35.0397 23.5142 35.2637 23.2907 35.2637 23.0142C35.2637 22.7377 35.0397 22.5142 34.7637 22.5142Z"
                fill="black"
            />
            <path
                d="M21.0137 22.5142H26.0137C26.2897 22.5142 26.5137 22.7377 26.5137 23.0142C26.5137 23.2907 26.2897 23.5142 26.0137 23.5142H21.0137C20.7372 23.5142 20.5137 23.2907 20.5137 23.0142C20.5137 22.7377 20.7372 22.5142 21.0137 22.5142Z"
                fill="black"
            />
            <path
                d="M17.2639 20.0142H12.2639C11.6139 20.0042 11.6164 21.0242 12.2639 21.0142H17.2639C17.9134 21.0242 17.9109 20.0042 17.2639 20.0142Z"
                fill="black"
            />
            <path
                d="M19.5137 17.2642C19.5137 17.5407 19.7372 17.7642 20.0137 17.7642H22.0137C22.2897 17.7642 22.5137 17.5407 22.5137 17.2642C22.5137 16.9877 22.2897 16.7642 22.0137 16.7642H20.0137C19.7372 16.7642 19.5137 16.9877 19.5137 17.2642Z"
                fill="black"
            />
            <path
                d="M17.0137 17.2642C17.0137 17.5407 16.7897 17.7642 16.5137 17.7642H14.5137C14.2372 17.7642 14.0137 17.5407 14.0137 17.2642C14.0137 16.9877 14.2372 16.7642 14.5137 16.7642H16.5137C16.7897 16.7642 17.0137 16.9877 17.0137 17.2642Z"
                fill="black"
            />
            <path
                d="M13.5137 17.2642C13.5137 16.8502 13.1777 16.5142 12.7637 16.5142C12.3497 16.5142 12.0137 16.8502 12.0137 17.2642C12.0137 17.6782 12.3497 18.0142 12.7637 18.0142C13.1777 18.0142 13.5137 17.6782 13.5137 17.2642Z"
                fill="black"
            />
            <path
                d="M17.5137 17.2642C17.5137 16.8502 17.8497 16.5142 18.2637 16.5142C18.6777 16.5142 19.0137 16.8502 19.0137 17.2642C19.0137 17.6782 18.6777 18.0142 18.2637 18.0142C17.8497 18.0142 17.5137 17.6782 17.5137 17.2642Z"
                fill="black"
            />
            <path
                d="M29.2637 20.5142C29.2637 20.7907 29.4872 21.0142 29.7637 21.0142H34.7637C35.0397 21.0142 35.2637 20.7907 35.2637 20.5142C35.2637 20.2377 35.0397 20.0142 34.7637 20.0142H29.7637C29.4872 20.0142 29.2637 20.2377 29.2637 20.5142Z"
                fill="black"
            />
            <path
                d="M21.0137 20.0142H26.0137C26.2897 20.0142 26.5137 20.2377 26.5137 20.5142C26.5137 20.7907 26.2897 21.0142 26.0137 21.0142H21.0137C20.7372 21.0142 20.5137 20.7907 20.5137 20.5142C20.5137 20.2377 20.7372 20.0142 21.0137 20.0142Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.7225 5.5C35.3955 5.5 36.0465 5.7345 36.556 6.1605C37.174 6.677 37.5285 7.427 37.5285 8.2185V41.014C37.5285 41.2985 37.2985 41.5285 37.014 41.5285H10.014C9.73 41.5285 9.5 41.2985 9.5 41.014V8.2185C9.5 7.5555 9.7485 6.917 10.2005 6.42C10.735 5.835 11.502 5.5 12.3055 5.5H34.7225ZM10.5285 40.5H36.5V8.2185C36.5 7.733 36.28 7.2705 35.896 6.9495C35.5715 6.678 35.1545 6.5285 34.7225 6.5285H12.3055C11.79 6.5285 11.3 6.7415 10.961 7.113C10.682 7.4195 10.5285 7.812 10.5285 8.2185V40.5Z"
                fill="black"
            />
        </svg>
    );
};

export const IntroIconQ: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2390)">
                <path d="M6 18.8359H17.4349" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M30.5645 18.8359H41.9993" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 34.6953H17.3401" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M30.5645 34.6953H41.9993" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.4426 13.2101H40.2461C41.2143 13.2101 42 13.9952 42 14.964V36.9778C42 37.9465 41.2143 38.7317 40.2461 38.7317H7.7539C6.78575 38.7317 6 37.9465 6 36.9778V14.964C6 13.9952 6.78575 13.2101 7.7539 13.2101H17.6605L19.6986 9.5H27.4859L29.4426 13.2101Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M38.8198 16.8789H34.5801" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M36.4956 11.9868H32.2559" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.0332 13.2099V11.9868H15.7433V13.2099" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.2955 26.7659C34.2955 32.4515 29.6868 37.0601 24.0013 37.0601C18.3157 37.0601 13.707 32.4515 13.707 26.7659C13.707 21.0803 18.3157 16.4717 24.0013 16.4717C29.6868 16.4717 34.2955 21.0803 34.2955 26.7659Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.7039 26.766C31.7039 31.0216 28.254 34.4715 23.9984 34.4715C19.7429 34.4715 16.293 31.0216 16.293 26.766C16.293 22.5105 19.7429 19.0605 23.9984 19.0605C28.254 19.0605 31.7039 22.5105 31.7039 26.766Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18.6934 26.2107C18.6934 23.5869 20.8208 21.46 23.4441 21.46" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_450_2390">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconR: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2381)">
                <path
                    d="M6.72656 35.1432V13.3195C6.72656 12.3148 7.54081 11.5 8.54551 11.5H39.4538C40.4585 11.5 41.2728 12.3148 41.2728 13.3195V35.1432"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M43.3889 36.9615H4.61107C4.27345 36.9615 4 36.688 4 36.3504V35.1639C4 35.1527 4.00917 35.1436 4.02037 35.1436H43.9791C43.9908 35.1436 44 35.1527 44 35.1639V36.3504C44 36.688 43.7265 36.9615 43.3889 36.9615Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.53711 33.3255H39.4459V13.3252H8.53711V33.3255Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_450_2381">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconS: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_450_2407)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.4408 13.8519C35.8078 14.4849 34.7815 14.4849 34.1485 13.8519C33.5156 13.219 33.5156 12.1926 34.1485 11.5597C34.7815 10.9267 35.8078 10.9267 36.4408 11.5597C37.0737 12.1926 37.0737 13.219 36.4408 13.8519Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M29.7461 7L34.2271 11.481" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M36.5195 13.7734L41.0005 18.2544" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34.1484 13.8516L32.0957 15.9043" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M27.9004 18.068L30.281 15.6881C30.7193 15.2498 31.4302 15.2498 31.8692 15.6881L32.313 16.1312C32.7513 16.5702 32.7513 17.2811 32.313 17.7201L29.9324 20.1"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20.0996 18.068L27.8999 18.0659" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M29.9344 20.1006L29.9316 27.9009" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.4408 13.8519C35.8078 14.4849 34.7815 14.4849 34.1485 13.8519C33.5156 13.219 33.5156 12.1926 34.1485 11.5597C34.7815 10.9267 35.8078 10.9267 36.4408 11.5597C37.0737 12.1926 37.0737 13.219 36.4408 13.8519Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M29.7461 7L34.2271 11.481" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M36.5195 13.7734L41.0005 18.2544" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34.1484 13.8516L32.0957 15.9043" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M27.9004 18.068L30.281 15.6881C30.7193 15.2498 31.4302 15.2498 31.8692 15.6881L32.313 16.1312C32.7513 16.5702 32.7513 17.2811 32.313 17.7201L29.9324 20.1"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.8509 11.5592C14.4839 12.1921 14.4839 13.2185 13.8509 13.8514C13.218 14.4844 12.1916 14.4844 11.5587 13.8514C10.9257 13.2185 10.9257 12.1921 11.5587 11.5592C12.1916 10.9262 13.218 10.9262 13.8509 11.5592Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 18.2544L11.4803 13.7734" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.7734 11.481L18.2544 7" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.8516 13.8516L15.9098 15.9091" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.0667 20.0995L15.6861 17.7196C15.2478 17.2813 15.2478 16.5697 15.6861 16.1307L16.13 15.6876C16.5689 15.2493 17.2799 15.2493 17.7182 15.6876L20.0988 18.0675"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18.0685 27.9006L18.0664 20.0996" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5587 34.149C12.1916 33.5161 13.218 33.5161 13.8509 34.149C14.4846 34.782 14.4846 35.8083 13.8509 36.4413C13.218 37.0742 12.1916 37.0742 11.5587 36.4413C10.9257 35.8083 10.9257 34.782 11.5587 34.149Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18.2544 41L13.7734 36.519" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.4803 34.2269L7 29.7466" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.8516 34.1489L15.936 32.0645" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.1007 29.9324L17.7201 32.3123C17.2818 32.7513 16.5709 32.7513 16.1319 32.3123L15.6881 31.8692C15.2498 31.4302 15.2498 30.7193 15.6881 30.2803L18.0687 27.9004"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M27.8999 29.9326L20.0996 29.9347" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.1485 36.4413C33.5156 35.8084 33.5156 34.782 34.1485 34.149C34.7815 33.5154 35.8078 33.5154 36.4408 34.149C37.0737 34.782 37.0737 35.8084 36.4408 36.4413C35.8078 37.0742 34.7815 37.0742 34.1485 36.4413Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M41.0005 29.7461L36.5195 34.2264" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34.2271 36.5195L29.7461 41.0005" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34.1499 34.1489L32.1172 32.1162" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M29.9305 27.9004L32.3111 30.2803C32.7494 30.7193 32.7494 31.4302 32.3111 31.8692L31.8672 32.3123C31.4283 32.7513 30.7173 32.7513 30.279 32.3123L27.8984 29.9324"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M24.8086 24.8086L23.1914 23.1914" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.1914 24.8086L24.8086 23.1914" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_450_2407">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IntroIconT: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.0579 15.7525C26.0409 16.8755 25.1349 17.757 23.9994 17.755C22.8254 17.753 21.9039 16.8025 21.9509 15.6415C21.9964 14.519 22.9204 13.6655 24.0594 13.6935C25.1944 13.7205 26.0744 14.6275 26.0579 15.7525Z"
                stroke="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.0795 27.5582C25.2185 27.5932 26.088 28.5057 26.059 29.6362C26.0305 30.7562 25.1035 31.6482 23.9815 31.6347C22.819 31.6212 21.897 30.6447 21.9515 29.4862C22.004 28.3602 22.9275 27.5232 24.0795 27.5582Z"
                stroke="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.3015 12.022C30.827 12.022 30.4415 11.637 30.4415 11.162C30.4415 10.687 30.827 10.302 31.3015 10.302C31.7765 10.302 32.1615 10.687 32.1615 11.162C32.1615 11.637 31.7765 12.022 31.3015 12.022ZM31.3015 37.6195C30.827 37.6195 30.4415 37.2345 30.4415 36.7595C30.4415 36.284 30.827 35.8995 31.3015 35.8995C31.7765 35.8995 32.1615 36.284 32.1615 36.7595C32.1615 37.2345 31.7765 37.6195 31.3015 37.6195ZM24.0005 36.199C20.35 36.1965 17.3755 33.193 17.3969 29.529C17.4185 25.91 20.365 23.0005 24.007 23.0015C27.691 23.003 30.6305 25.957 30.6111 29.6385C30.592 33.2405 27.609 36.2005 24.0005 36.199ZM16.706 37.6195C16.2305 37.6195 15.846 37.2345 15.846 36.7595C15.846 36.284 16.2305 35.8995 16.706 35.8995C17.181 35.8995 17.5665 36.284 17.5665 36.7595C17.5665 37.2345 17.181 37.6195 16.706 37.6195ZM16.706 10.302C17.181 10.302 17.5665 10.687 17.5665 11.162C17.5665 11.637 17.181 12.022 16.706 12.022C16.2305 12.022 15.846 11.637 15.846 11.162C15.846 10.687 16.2305 10.302 16.706 10.302ZM23.998 11.535C26.299 11.532 28.177 13.4255 28.1695 15.743C28.1625 18.017 26.337 19.866 24.062 19.9045C21.7595 19.943 19.849 18.0655 19.8385 15.755C19.8285 13.4335 21.696 11.539 23.998 11.535ZM33.681 11.0195C33.677 9.241 32.9475 8.5095 31.169 8.5065C26.384 8.498 21.598 8.4975 16.8125 8.507C15.0525 8.5105 14.327 9.2545 14.326 11.0455C14.321 19.5845 14.321 28.1235 14.326 36.6625C14.3265 38.5065 15.0455 39.225 16.8905 39.2285C21.607 39.236 26.324 39.2345 31.0405 39.229C33.007 39.2265 33.682 38.534 33.6835 36.5335C33.687 32.333 33.6845 28.1325 33.684 23.9315C33.6835 19.6275 33.6885 15.324 33.681 11.0195Z"
                stroke="black"
            />
            <path d="M11.1621 20.1597V27.5617" stroke="black" strokeLinecap="round" />
            <path d="M8.83203 17.2622V30.4717" stroke="black" strokeLinecap="round" />
            <path d="M6.55273 19.873V27.425" stroke="black" strokeLinecap="round" />
            <path d="M4.31055 21.7461V25.7181" stroke="black" strokeLinecap="round" />
            <path d="M36.8438 27.5734V20.1714" stroke="black" strokeLinecap="round" />
            <path d="M39.1758 30.4717V17.2622" stroke="black" strokeLinecap="round" />
            <path d="M41.4531 27.8601V20.3081" stroke="black" strokeLinecap="round" />
            <path d="M43.6953 25.9876V22.0156" stroke="black" strokeLinecap="round" />
        </svg>
    );
};

export const IntroIconU: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5.92793" y="8.83662" width="36.1437" height="25.2323" rx="1.23924" stroke="black" strokeWidth="1.48966" />
            <path d="M5.66162 29.5508H42.3376" stroke="black" strokeWidth="1.48966" />
            <path d="M23.1366 31.7456L24.862 31.7456" stroke="black" strokeWidth="1.48966" strokeLinecap="round" />
            <path d="M20.1829 34.814L19.7354 37.363" stroke="black" strokeWidth="1.48966" strokeLinecap="square" />
            <path d="M27.8157 34.814L28.2632 37.363" stroke="black" strokeWidth="1.48966" strokeLinecap="square" />
            <mask id="path-6-inside-1_114_25639" fill="white">
                <rect x="15.8975" y="37.3628" width="15.8636" height="2.545" rx="0.992035" />
            </mask>
            <rect
                x="15.8975"
                y="37.3628"
                width="15.8636"
                height="2.545"
                rx="0.992035"
                stroke="black"
                strokeWidth="2.23448"
                mask="url(#path-6-inside-1_114_25639)"
            />
        </svg>
    );
};

export const IntroIconV: FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.994 10.7588C42.5779 10.7588 43.8618 12.0427 43.8618 13.6266V25.4588C43.8618 27.0427 42.5779 28.3266 40.994 28.3266H7.00548C5.42165 28.3266 4.1377 27.0427 4.1377 25.4588V13.6266C4.1377 12.0427 5.42165 10.7588 7.00548 10.7588H40.994ZM9.15101 21.1997C9.15101 20.789 9.48388 20.4562 9.89451 20.4562H38.105C38.3022 20.4562 38.4913 20.5345 38.6308 20.6739C38.7702 20.8134 38.8485 21.0025 38.8485 21.1997L38.8479 26.8396L40.994 26.8396C41.7566 26.8396 42.3748 26.2214 42.3748 25.4588V13.6266C42.3748 12.864 41.7566 12.2458 40.994 12.2458L38.8479 12.2447L38.8485 13.8709C38.8253 15.356 37.6147 16.5476 36.1294 16.5475H11.8701C10.3766 16.5593 9.15306 15.3643 9.12977 13.8709L9.12928 12.2447L7.00548 12.2458C6.63927 12.2458 6.28807 12.3913 6.02912 12.6502C5.77017 12.9092 5.6247 13.2604 5.6247 13.6266V25.4588C5.6247 26.2214 6.24289 26.8396 7.00548 26.8396L9.15038 26.8396L9.15101 21.1997ZM37.3615 25.1296H10.638V26.829H37.3615V25.1296ZM37.3615 21.9432H10.638V23.6426H37.3615V21.9432ZM37.3615 12.2458L10.638 12.2989V13.8709C10.638 14.5513 11.1896 15.103 11.8701 15.103H36.1294C36.8099 15.103 37.3615 14.5513 37.3615 13.8709V12.2458ZM16.7878 40.3501C16.5246 40.3477 16.2822 40.2063 16.1505 39.9783L15.1521 38.3001C14.7743 37.6587 14.6818 36.8885 14.8972 36.1759C15.0933 35.4713 15.5587 34.8723 16.193 34.5083C16.4914 34.3398 16.7124 34.0617 16.8091 33.7329C16.8949 33.4147 16.8529 33.0754 16.6922 32.7876L15.6938 31.0563C15.5293 30.8254 15.5105 30.521 15.6453 30.2715C15.7801 30.0221 16.045 29.871 16.3283 29.882C16.6116 29.8931 16.864 30.0643 16.979 30.3235L17.9774 32.0441C18.3578 32.6847 18.4503 33.456 18.2323 34.1684C18.0416 34.8756 17.5747 35.4765 16.9365 35.836C16.6396 36.0111 16.4196 36.2918 16.3205 36.622C16.2358 36.9403 16.2777 37.2791 16.4373 37.5673L17.4357 39.2879C17.5348 39.4579 17.5613 39.6606 17.5094 39.8504C17.4575 40.0402 17.3314 40.2011 17.1596 40.297C17.0431 40.3492 16.9143 40.3676 16.7878 40.3501ZM24.2228 40.3501C23.9596 40.3477 23.7172 40.2063 23.5855 39.9783L22.5871 38.3001C22.2093 37.6587 22.1168 36.8885 22.3322 36.1759C22.5282 35.4713 22.9937 34.8723 23.628 34.5083C23.9264 34.3398 24.1474 34.0617 24.2441 33.7329C24.3299 33.4147 24.2879 33.0754 24.1272 32.7876L23.1288 31.0563C22.9643 30.8254 22.9455 30.521 23.0803 30.2715C23.215 30.0221 23.48 29.871 23.7633 29.882C24.0466 29.8931 24.299 30.0643 24.414 30.3235L25.4124 32.0441C25.7928 32.6847 25.8853 33.456 25.6673 34.1684C25.4766 34.8756 25.0097 35.4765 24.3715 35.836C24.0746 36.0111 23.8546 36.2918 23.7555 36.622C23.6708 36.9403 23.7127 37.2791 23.8723 37.5673L24.8707 39.2879C24.9698 39.4579 24.9963 39.6606 24.9444 39.8504C24.8925 40.0402 24.7664 40.2011 24.5946 40.297C24.4781 40.3492 24.3493 40.3676 24.2228 40.3501ZM31.6578 40.3501C31.3945 40.3477 31.1522 40.2063 31.0205 39.9783L30.0221 38.3001C29.6443 37.6587 29.5518 36.8885 29.7672 36.1759C29.9632 35.4713 30.4287 34.8723 31.063 34.5083C31.3614 34.3398 31.5824 34.0617 31.6791 33.7329C31.7649 33.4147 31.7229 33.0754 31.5622 32.7876L30.5638 31.0563C30.3993 30.8254 30.3805 30.521 30.5153 30.2715C30.65 30.0221 30.915 29.871 31.1983 29.882C31.4816 29.8931 31.734 30.0643 31.849 30.3235L32.8474 32.0441C33.2278 32.6847 33.3203 33.456 33.1023 34.1684C32.9116 34.8756 32.4447 35.4765 31.8065 35.836C31.5096 36.0111 31.2896 36.2918 31.1905 36.622C31.1058 36.9403 31.1477 37.2791 31.3073 37.5673L32.3057 39.2879C32.4048 39.4579 32.4313 39.6606 32.3794 39.8504C32.3275 40.0402 32.2014 40.2011 32.0296 40.297C31.9131 40.3492 31.7843 40.3676 31.6578 40.3501Z"
                fill="black"
            />
        </svg>
    );
};
